module.exports = __webpack_public_path__ + "static/Bg12-32365d331bcfc20ca029b7e5eb7fdf06.png";